import React from 'react';

import type { MultichainPortfolioConfig } from 'types/client/multichainPortfolioConfig';

import useApiQuery from 'lib/api/useApiQuery';

type Params = {
  addressHash: string;
  chainsConfig?: MultichainPortfolioConfig;
  enabled?: boolean;
};

const DEFAULT_STALE_MS = 3_600_000;

export default function useMultichainPortfolio({ addressHash, chainsConfig, enabled = true }: Params) {
  const chainIds = chainsConfig?.chains.map((chain) => chain.id).join(',');
  const isEnabled = Boolean(enabled && chainsConfig && chainIds);
  const [ staleTimeMs, setStaleTimeMs ] = React.useState(DEFAULT_STALE_MS);

  const query = useApiQuery('address_multichain_portfolio', {
    pathParams: { hash: addressHash },
    queryParams: { chains: chainIds },
    queryOptions: {
      enabled: isEnabled,
      staleTime: staleTimeMs,
      retry: false,
    },
  });

  React.useEffect(() => {
    const ttlSeconds = query.data?.cache_ttl_seconds;

    if (ttlSeconds && ttlSeconds * 1000 !== staleTimeMs) {
      setStaleTimeMs(ttlSeconds * 1000);
    }
  }, [ query.data?.cache_ttl_seconds, staleTimeMs ]);

  return query;
}
